import classNames from "classnames";

import styles from "./CardKleeActions.module.css";

const CardKleeActions: React.FC<CardKleeActionsProps> = ({
  children,
  noPadding,
}) => {
  return (
    <div
      className={classNames(styles.actions, { [styles.noPadding]: noPadding })}
    >
      {children}
    </div>
  );
};

type CardKleeActionsProps = {
  noPadding?: boolean;
};

export default CardKleeActions;
